import { Component, inject, OnInit, signal } from '@angular/core';
import { Router, RouterModule } from '@angular/router';
import { DatePipe } from '@angular/common';
import { DashboardService } from './dashboard.service';
import {
  DashboardSummary,
  EquipoNoDevuelto,
  MaterialCritico,
} from './dashboard.models';

@Component({
  selector: 'app-dashboard',
  standalone: true,
  imports: [RouterModule, DatePipe],
  templateUrl: './dashboard.html',
})
export class Dashboard implements OnInit {
  private dashboardService = inject(DashboardService);
  private router = inject(Router);

  loading = signal(true);
  error = signal<string | null>(null);

  summary = signal<DashboardSummary | null>(null);
  materialesCriticos = signal<MaterialCritico[]>([]);
  equiposNoDevueltos = signal<EquipoNoDevuelto[]>([]);

  ngOnInit() {
    this.loadDashboard();
  }

  loadDashboard() {
    this.loading.set(true);
    this.error.set(null);

    this.dashboardService.getCompleto(10).subscribe({
      next: (data) => {
        this.summary.set(data.summary);
        this.materialesCriticos.set(data.materialesCriticos);
        this.equiposNoDevueltos.set(data.equiposNoDevueltos);
        this.loading.set(false);
      },
      error: (err) => {
        this.error.set(err.message || 'Error al cargar el dashboard');
        this.loading.set(false);
      },
    });
  }

  verMaterial(id: number) {
    this.router.navigate(['/material', id]);
  }

  verPedido(id: number) {
    this.router.navigate(['/pedido', id]);
  }

  verEquipo(id: number) {
    this.router.navigate(['/equipo', id]);
  }
}
